export default "__VITE_ASSET__48vDDsF$__"